import React from 'react';
import { Button, Flex } from 'common/common-components.styled';
import { useEditUplaodDocumentExecutorTask } from './use-edit-upload-document-executor-task';
import FormHook from 'components/form-hook/form-hook';
import { useForm } from 'react-hook-form';
import { EditUploadDocumentExecutorTaskProps } from './edit-upload-docuument-executor-task.types';

const EditUploadDocumentExecutorTask: React.FC<EditUploadDocumentExecutorTaskProps> = ({
  files,
  taskId,
  onCancel,
  refresh
}) => {
  const reactHookFormData = useForm();
  const { formFields, sumbitButtonDisabled, onSubmit } = useEditUplaodDocumentExecutorTask({
    reactHookFormData,
    files,
    taskId,
    refresh,
    onCancel
  });

  return (
    <Flex top='30' direction='column'>
      <Flex>
        <FormHook reactHookFormData={reactHookFormData} formFields={formFields} />
      </Flex>

      <Flex justify='flex-end' gap='10px'>
        <Button secondary onClick={onCancel}>
          Abbrechen
        </Button>
        <Button disabled={sumbitButtonDisabled} onClick={onSubmit}>
          Speichern
        </Button>
      </Flex>
    </Flex>
  );
};

export default EditUploadDocumentExecutorTask;
